<template>
   <div>
<!--     <Loading v-if="common.loading == true" />-->
     <keep-alive>
      <router-view/>

     </keep-alive>
    <KakaoPopup/>
     <button
         v-show="showScrollButton"
         @click="scrollToTop"
         class="btn btn-primary btn-lg scroll-to-top">
       <svg class="ast-arrow-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="26px" height="16.043px" viewBox="57 35.171 26 16.043" enable-background="new 57 35.171 26 16.043" xml:space="preserve">
                <path d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"></path>
                </svg>
     </button>
   </div>
</template>

<script>
import index from './views/app/index'
import KakaoPopup from "@/container/KakaoPopup";
import Loading from '@/container/Loading';
export default {
  name: 'App',
  components: {
    KakaoPopup,
    index,
    Loading
  },
  data(){
    return {
      showScrollButton: false, // 버튼 표시 여부
    };
  },
  methods: {
    handleScroll() {
      // 스크롤 위치가 200px 이상이면 버튼 표시
      // console.log(window.scrollY);
      // this.showScrollButton = window.scrollY > 200;
      // console.log(this.showScrollButton);
    },
    scrollToTop() {
      // 부드럽게 상단으로 이동
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    // 컴포넌트가 마운트되면 스크롤 이벤트 리스너 추가
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // 컴포넌트가 언마운트되면 이벤트 리스너 제거
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>

<style>
.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background:#0069c1;
  padding: 0;
  width: 42px;
  height: 42px;
  border-radius: 50px;
}
.scroll-to-top:hover{
  background-color:#0059A3;
}
.scroll-to-top[style*="display: block;"] {
  display: block !important; /* v-show가 적용될 때 표시 */
}
.scroll-to-top svg {
  margin-left: 0px;
  vertical-align: middle;
  transform: translate(0, -20%) rotate(180deg);
  width: 1.6em;
  fill:#fff;
  height: 12px;
}
</style>
